import React from 'react';

import { type RouteComponentProps, Route, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../helpers/utilities';
import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';

const KioskServiceMFE = lazyWithRetry(() => import('./KioskService'));

type Props = RouteComponentProps;

const KioskServiceRoutes: React.FC<Props> = (props: Props) => {
  const {
    match: { path },
  } = props;

  return (
    <ErrorBoundary identifier="kiosk-service-mf">
      <Switch>
        <Route
          path={`${path}`}
          render={() => (
            <LazyComponent>
              <KioskServiceMFE />
            </LazyComponent>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default KioskServiceRoutes;
